import { apiFetch } from '@/lib/api'
import type { McpConsentService } from '@/services/contracts'

interface ConsentInfoDto {
  client_name: string
  has_permission: boolean
}

interface ConsentRedirectDto {
  redirect_url: string
}

const redirect = async (path: string, request: string) =>
  (await apiFetch<ConsentRedirectDto>(path, { method: 'POST', body: { request } })).redirect_url

export const httpMcpConsentService: McpConsentService = {
  async info(request) {
    const dto = await apiFetch<ConsentInfoDto>('/mcp/consent/info', {
      method: 'POST',
      body: { request },
    })
    return { clientName: dto.client_name, hasPermission: dto.has_permission }
  },
  approve: (request) => redirect('/mcp/consent/approve', request),
  deny: (request) => redirect('/mcp/consent/deny', request),
}
